import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathpoint"
    }}>{`PathPoint`}</h1>
    <p>{`Represents the anchor and control-handle endpoints for a path segment. Each point (the anchor point, left-direction
point, and right-direction point) is an array containing X and Y position coordinates.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Use the `}<inlineCode parentName="p">{`PathPoint`}</inlineCode>{` object to retrieve information about the points that describe existing path segments. The
properties are read-only. Access `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathpoint/"
          }}>{`PathPoint`}</a>{` objects through the `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/subpathitem/#pathpoints"
          }}>{`SubPathItem.pathPoints`}</a>{` property.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathpointinfo/"
          }}>{`PathPointInfo`}</a>{` with `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
          }}>{`PathItems.add`}</a>{`() to create path points. The properties are writeable.`}</p>
      </li>
    </ul>
    <p>{`For paths that are straight segments (not curved), the coordinates of all three points are the same. For curved
segments, the coordinates are different. The difference between the anchor point and the left or right
direction points determines the arc of the curve. Use the left direction point to bend the curve "outward" or
make it convex; or use the right direction point to bend the curve "inward" or make it concave.`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`anchor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The coordinates of the anchor point of the curve, in `}{`\``}{`[horizontal, vertical]`}{`\``}{` format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`kind`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/constants/#pointkind"
            }}><em parentName="a">{`PointKind`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The role (corner or smooth) this point plays in the containing path segment.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`leftDirection`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The location of the left-direction endpoint (`}{`'`}{`in`}{`'`}{` position), in `}{`\``}{`[horizontal, vertical]`}{`\``}{` format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
            }}><em parentName="a">{`SubPathItem`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The containing SubPath object`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rightDirection`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em>{`[]`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The location of the right-direction endpoint (`}{`'`}{`out`}{`'`}{` position), in `}{`\``}{`[horizontal, vertical]`}{`\``}{` format.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced object`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      